var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhiLiangJianChaWeihui(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 42 42"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "currentColor",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.305 12.665l.039.126c.427 1.457.656 2.999.656 4.594 0 7.327-4.834 13.53-11.499 15.615C13.835 30.915 9 24.712 9 17.385c0-1.642.243-3.227.694-4.721A16.4 16.4 0 0020.5 8a16.4 16.4 0 0010.805 4.664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.43 22.66l-2.347 1.21.448-2.565-1.9-1.816 2.625-.374 1.174-2.334 1.174 2.334 2.624.374-1.9 1.816.45 2.565z"
  })));
}
export default SvgZhiLiangJianChaWeihui;